import { TriangleIcon } from "lucide-react";

import { cn } from "@/lib/cn";
import { formatCurrency } from "@/lib/utils";

interface ProfitBadgeProps {
  value: number;
  type?: "currency" | "percent";
  size?: "sm" | "md";
  showArrow?: boolean;
  className?: string;
}

export const ProfitBadge = ({
  value,
  type = "currency",
  size = "sm",
  showArrow = true,
  className,
}: ProfitBadgeProps) => {
  const isPositive = value >= 0;
  const absValue = formatCurrency(Math.abs(value), 1);

  // md: показываем знак +/- отдельно
  const showSign = size === "md";
  const sign = isPositive ? "+" : "-";

  // Форматированное значение (без знака для md, со знаком $ для sm)
  const formattedValue =
    type === "currency" ? (size === "md" ? `${absValue} $` : `$ ${absValue}`) : `${absValue}%`;

  const arrow = showArrow ? (
    <TriangleIcon className={cn("size-2 fill-current", !isPositive && "rotate-180")} />
  ) : null;

  return (
    <div
      className={cn(
        // Layout - explicit flex-row to prevent col fallback
        "inline-flex shrink-0 flex-row items-center justify-center gap-0.5",
        "rounded-full",
        "pr-1.5 pl-1",
        // Background
        isPositive ? "bg-primary-500/22 text-primary-500" : "bg-red-500/25 text-red-500",
        // Size variants
        size === "sm" && "fs-100",
        size === "md" && "fs-200",
        className
      )}
    >
      {arrow}
      {showSign && <span className="font-bold">{sign}</span>}
      <span className="font-medium">{formattedValue}</span>
    </div>
  );
};
